<template>
<div class="chapter">
<div class="inner_page">
<section class="level1" data-number="2" id="chapter-one">
<h1 data-number="2">Chapter One</h1>
<p>The girl pulled the duvet over her head and tried to return to sleep.</p>
<p>Her skin bristled with heat beneath the cover and she stuck her head back out. ‘Mummy?’ she whispered, her words lost in the darkness.</p>
<p>Her toys acted as if nothing was happening. She grabbed Laney and studied her face, the glass eyes and stitched smile revealing no sense of fear. A crashing noise came from downstairs and she retreated back further beneath the covers with her doll.</p>
<p>It was hot, and not just because she was wrapped in the duvet. She wanted to leave the room, to make the small journey to Mummy and Daddy’s room, but they didn’t like her leaving her bed in the middle of the night and she wanted to be a good girl. Mummy would come to her if anything was wrong, she was sure. She listened, but all she could hear was the rapid thumping of her heart.</p>
<p>‘What do you think?’ she asked Laney, as more noises rose from the depths of the house. The sounds were familiar but she couldn’t recall from where. She closed her eyes and pictured the dragon from the book Mummy read to her at bedtime.</p>
<p>She poked Laney’s head out of the duvet and turned the doll’s face in a circle so she could check nothing was in the room with them. Laney didn’t say anything so she stuck her head back out.</p>
<p>The room had changed. She rubbed her eyes. She must be tired. Mummy and Daddy always said she was tired when things were going wrong. Her eyes watered, and the room faded. She glanced down at the nightlight, peering closer at the air which danced around its orange glow. Then the door blew open.</p>
<p>She grabbed Laney closer and started to cough. A strange figure stood in her doorway. He wore a helmet and a funny mask. Behind him, something glowed like her nightlight but much brighter. It had changed the house. The man mumbled something and she struggled to keep her eyes open as he grabbed her from the bed and placed something over her mouth.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?23d82e5a